"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return value.toString();
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/toString.js
// module id = 792
// module chunks = 0